export class IbResponse {
    status: any;
    statusDescription: string;
    exception: any;
    param1: string;
    param2: string;
    param3: string;
    param4: string;
    param5: any;
    param6: any;
    param7: any;
    param8: any;
    param9: any;
}



// WEBPACK FOOTER //
// D:/Sonali/JCCBViewOnlyProject/ViewOnlyJCCBfrontend19112022/InternetBanking6.3frontend/src/app/ib-response.ts